import React, { useState } from 'react'

const Welcome = () => {
  const [count, setCount] = useState(0)

  const increment = () => setCount(count + 1)
  const decrement = () => setCount(count - 1)

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Welcome to the React Welcome Component</h2>
      <div className="flex flex-col items-center gap-4">
        <div className="text-4xl font-bold text-blue-600">{count}</div>
        <div className="flex gap-3">
          <button
            onClick={decrement}
            className="px-6 py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 active:bg-red-700 transition-colors"
          >
            Decrement
          </button>
          <button
            onClick={increment}
            className="px-6 py-2 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 active:bg-green-700 transition-colors"
          >
            Increment
          </button>
        </div>
      </div>
    </div>
  )
}

export default Welcome